import { render, staticRenderFns } from "./Emailverification.vue?vue&type=template&id=272dcb83"
import script from "./Emailverification.vue?vue&type=script&lang=js"
export * from "./Emailverification.vue?vue&type=script&lang=js"
import style0 from "./Emailverification.vue?vue&type=style&index=0&id=272dcb83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports